import React from 'react';

import { ApiSectionContext } from '../contexts';

/**
 * A temporary provider that signals to API hooks that they are in the MMB (Manage My Booking) section.
 * This makes `useEnnismoreApiClientConfig` use the `feature-api-gateway-mmb` flag
 * instead of the default `feature-api-gateway` flag.
 */
export const MmbApiSectionProvider = ({ children }) => {
  return (
    <ApiSectionContext.Provider value="mmb">
      {children}
    </ApiSectionContext.Provider>
  );
};
